import { render, staticRenderFns } from "./Contactds.vue?vue&type=template&id=3de3ecb5&scoped=true&"
import script from "./Contactds.vue?vue&type=script&lang=js&"
export * from "./Contactds.vue?vue&type=script&lang=js&"
import style0 from "./Contactds.vue?vue&type=style&index=0&id=3de3ecb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de3ecb5",
  null
  
)

export default component.exports